import { __extends } from "tslib";
import { NormalBasicMethod, _Shader_NormalBasicMethod } from './NormalBasicMethod';
/**
 * NormalHeightMapMethod provides a normal map method that uses a height map to calculate the normals.
 */
var NormalHeightMapMethod = /** @class */ (function (_super) {
    __extends(NormalHeightMapMethod, _super);
    /**
     * Creates a new NormalHeightMapMethod method.
     *
     * @param heightMap The texture containing the height data. 0 means low, 1 means high.
     * @param worldWidth The width of the 'world'. This is used to map uv coordinates' u component to scene dimensions.
     * @param worldHeight The height of the 'world'. This is used to map the height map values to scene dimensions.
     * @param worldDepth The depth of the 'world'. This is used to map uv coordinates' v component to scene dimensions.
     */
    function NormalHeightMapMethod(heightMap, worldWidth, worldHeight, worldDepth) {
        var _this = _super.call(this) || this;
        _this.texture = heightMap;
        _this._worldXYRatio = worldWidth / worldHeight;
        _this._worldXZRatio = worldDepth / worldHeight;
        return _this;
    }
    Object.defineProperty(NormalHeightMapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return NormalHeightMapMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NormalHeightMapMethod.prototype, "worldXYRatio", {
        get: function () {
            return this._worldXYRatio;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NormalHeightMapMethod.prototype, "worldXZRatio", {
        get: function () {
            return this._worldXZRatio;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    NormalHeightMapMethod.prototype.copyFrom = function (method) {
        _super.prototype.copyFrom.call(this, method);
        this._worldXYRatio = method._worldXYRatio;
        this._worldXZRatio = method._worldXZRatio;
    };
    NormalHeightMapMethod.assetType = '[asset NormalHeightMapMethod]';
    return NormalHeightMapMethod;
}(NormalBasicMethod));
export { NormalHeightMapMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_NormalHeightMapMethod provides a normal map method that uses a height map to calculate the normals.
 */
var _Shader_NormalHeightMapMethod = /** @class */ (function (_super) {
    __extends(_Shader_NormalHeightMapMethod, _super);
    /**
     * Creates a new _Shader_NormalHeightMapMethod.
     */
    function _Shader_NormalHeightMapMethod(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_NormalHeightMapMethod.prototype._initConstants = function () {
        _super.prototype._initConstants.call(this);
        var index = this._fragmentConstantsIndex;
        var data = this._shader.fragmentConstantData;
        var image = this._method.texture.image;
        data[index] = 1 / image.width;
        data[index + 1] = 1 / image.height;
        data[index + 2] = 0;
        data[index + 3] = 1;
        data[index + 4] = this._method.worldXYRatio;
        data[index + 5] = this._method.worldXZRatio;
    };
    Object.defineProperty(_Shader_NormalHeightMapMethod.prototype, "tangentSpace", {
        /**
         * @inheritDoc
         */
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    _Shader_NormalHeightMapMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = '';
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        var dataReg = registerCache.getFreeFragmentConstant();
        var dataReg2 = registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = dataReg.index * 4;
        code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
            'add ' + temp + ', ' + sharedRegisters.uvVarying + ', ' + dataReg + '.xzzz\n' +
            this._texture._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            'sub ' + targetReg + '.x, ' + targetReg + '.x, ' + temp + '.x\n' +
            'add ' + temp + ', ' + sharedRegisters.uvVarying + ', ' + dataReg + '.zyzz\n' +
            this._texture._getFragmentCode(temp, registerCache, sharedRegisters, temp) +
            'sub ' + targetReg + '.z, ' + targetReg + '.z, ' + temp + '.x\n' +
            'mov ' + targetReg + '.y, ' + dataReg + '.w\n' +
            'mul ' + targetReg + '.xz, ' + targetReg + '.xz, ' + dataReg2 + '.xy\n' +
            'nrm ' + targetReg + '.xyz, ' + targetReg + '.xyz\n';
        registerCache.removeFragmentTempUsage(temp);
        return code;
    };
    return _Shader_NormalHeightMapMethod;
}(_Shader_NormalBasicMethod));
export { _Shader_NormalHeightMapMethod };
ShaderBase.registerAbstraction(_Shader_NormalHeightMapMethod, NormalHeightMapMethod);
